var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2917 10.295L13.0017 12.595L13.0017 3.00499C13.0017 2.4527 12.554 2.00499 12.0017 2.00499C11.4495 2.00499 11.0017 2.4527 11.0017 3.00499L11.0017 12.595L8.71175 10.295C8.52398 10.1057 8.26838 9.99919 8.00175 9.99919C7.73511 9.99919 7.47951 10.1057 7.29175 10.295C7.10243 10.4828 6.99595 10.7383 6.99595 11.005C6.99595 11.2716 7.10243 11.5272 7.29175 11.715L11.2917 15.715C11.3868 15.806 11.499 15.8774 11.6217 15.925C11.8652 16.025 12.1383 16.025 12.3817 15.925C12.5045 15.8774 12.6166 15.806 12.7117 15.715L16.7117 11.715C16.9654 11.4613 17.0645 11.0916 16.9716 10.7451C16.8788 10.3986 16.6081 10.128 16.2616 10.0351C15.9151 9.94226 15.5454 10.0413 15.2917 10.295Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 12C20.4477 12 20 12.4477 20 13V19C20 19.5523 19.5523 20 19 20H5C4.44772 20 4 19.5523 4 19V13C4 12.4477 3.55228 12 3 12C2.44772 12 2 12.4477 2 13V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V13C22 12.4477 21.5523 12 21 12Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default ForwardRef;